var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcesoSolicitudCrditos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 129.75,
    height: 129.001,
    viewBox: "0 0 129.75 129.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4083",
    d: "M0-682.665H80.3v80.3H0Z",
    transform: "translate(0 682.665)",
    fill: "#3b0310"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23117",
    "data-name": "Grupo 23117",
    transform: "translate(0.519 0.524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23102",
    "data-name": "Grupo 23102",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15672",
    "data-name": "Grupo 15672",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15056",
    "data-name": "Grupo 15056",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_17",
    "data-name": "Uni\\xF3n 17",
    d: "M5.86,82.5H126.053s-27.324,32.129-66.618,33q-.748.017-1.484.017C19.783,115.518,5.86,82.5,5.86,82.5Zm.2,0S-3.367,70.319,1.294,46.789c2.931-14.8,15.245-22.134,31.752-21.433,5.675.241,14.907-6.931,28.172-15.74,28.374-18.843,69.419-10.84,59.6,31.544C116.06,61.671,135.766,62,125.972,82.5Z",
    fill: "#d5dced",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0.3
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23106",
    "data-name": "Grupo 23106",
    transform: "translate(11.626 31.014)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_1793",
    "data-name": "Elipse 1793",
    cx: 21.413,
    cy: 21.413,
    rx: 21.413,
    ry: 21.413,
    fill: "#7eccc9",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23105",
    "data-name": "Grupo 23105",
    transform: "translate(12.596 17.167)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_1790",
    "data-name": "Elipse 1790",
    cx: 6.733,
    cy: 7.447,
    rx: 6.733,
    ry: 7.447,
    transform: "translate(43.101 19.921)",
    fill: "#f15894"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_86412",
    "data-name": "Rect\\xE1ngulo 86412",
    width: 14.275,
    height: 25.696,
    transform: "translate(1.571 1.929)",
    fill: "#7eccc9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_86413",
    "data-name": "Rect\\xE1ngulo 86413",
    width: 14.275,
    height: 25.696,
    transform: "translate(64.383 53.321)",
    fill: "#7eccc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108583",
    "data-name": "Trazado 108583",
    d: "M-3112.211-12975.258h6.485v-7.355l-5.41,3.043Z",
    transform: "translate(3182.003 13016.503)",
    fill: "#ee2b7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108584",
    "data-name": "Trazado 108584",
    d: "M0,7.356H6.484V0L1.074,3.043Z",
    transform: "translate(29.878 34.759) rotate(90)",
    fill: "#ee2b7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108585",
    "data-name": "Trazado 108585",
    d: "M0,7.356H6.484V0L1.074,3.043Z",
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, 70.32, 20.671)",
    fill: "#ee2b7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108586",
    "data-name": "Trazado 108586",
    d: "M-3149.552-12984.565h2.329s10.462,5.865,13.676,6.22,6.389,2.4,8.208,1.224,4.719-2.969,3.457-5.366-10.754-7.095-10.754-7.095-3.941-4.806.543-5.354,17.316-.62,17.316-.62l-9.565-7.7h-25.209Z",
    transform: "translate(3166.039 13007.674)",
    fill: "#fce3ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108587",
    "data-name": "Trazado 108587",
    d: "M-3099.694-12966.771v21.258h-32.361s-7.531-1.164-11.427-4.835-10.6-10.68-10.6-10.68-.8-5.976,3.7-5.743,8.317,6.8,8.317,6.8,7.788,5.428,8.477,5.583-1.525-5.423,1.54-6.644,11.756-.827,11.756-.827,3.853-4.434,6.754-5.484,6.7-2.094,9.028-1.136S-3099.694-12966.771-3099.694-12966.771Z",
    transform: "translate(3164.077 13022.386)",
    fill: "#fce3ed"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g4077",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4079"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4081",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4087",
    transform: "translate(20.611 32.765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4089",
    d: "M-64.139-62.375A1.764,1.764,0,0,1-65.9-64.139a5.027,5.027,0,0,0-5.021-5.021,1.764,1.764,0,0,1-1.764-1.764,1.764,1.764,0,0,1,1.764-1.764,8.559,8.559,0,0,1,8.55,8.55A1.764,1.764,0,0,1-64.139-62.375Z",
    transform: "translate(72.689 72.689)",
    fill: "#3b0310"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4091",
    transform: "translate(67.562 32.765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4093",
    d: "M-13.236-62.375A1.764,1.764,0,0,1-15-64.139a8.559,8.559,0,0,1,8.55-8.55,1.764,1.764,0,0,1,1.764,1.764A1.764,1.764,0,0,1-6.45-69.161a5.027,5.027,0,0,0-5.021,5.021A1.764,1.764,0,0,1-13.236-62.375Z",
    transform: "translate(15 72.689)",
    fill: "#3b0310"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4095",
    transform: "translate(67.562 10.888)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4097",
    d: "M-6.45-4.686A8.559,8.559,0,0,1-15-13.236,1.764,1.764,0,0,1-13.236-15a1.764,1.764,0,0,1,1.764,1.764A5.027,5.027,0,0,0-6.45-8.215,1.764,1.764,0,0,1-4.686-6.45,1.764,1.764,0,0,1-6.45-4.686Z",
    transform: "translate(15 15)",
    fill: "#3b0310"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4099",
    transform: "translate(49.244 41.421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4101",
    fill: "#3b0310"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4103",
    transform: "translate(47.48 10.782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4105",
    d: "M11.194,17.4H-6.178a1.764,1.764,0,0,1-1.764-1.764,1.764,1.764,0,0,1,1.764-1.764H11.194a.781.781,0,0,0,.78-.78V-10.691a.781.781,0,0,0-.78-.78h-24.43A1.764,1.764,0,0,1-15-13.236,1.764,1.764,0,0,1-13.236-15h24.43A4.314,4.314,0,0,1,15.5-10.691V13.094A4.314,4.314,0,0,1,11.194,17.4Z",
    transform: "translate(15 15)",
    fill: "#3b0310"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4107",
    transform: "translate(20.505 23.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4109",
    d: "M-162.652-132.721h-17.373a4.314,4.314,0,0,1-4.309-4.309v-13.618a1.764,1.764,0,0,1,1.764-1.764,1.764,1.764,0,0,1,1.764,1.764v13.618a.781.781,0,0,0,.78.78h17.373a1.764,1.764,0,0,1,1.764,1.764A1.764,1.764,0,0,1-162.652-132.721Z",
    transform: "translate(184.333 152.412)",
    fill: "#3b0310"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4111",
    transform: "translate(40.369 17.595)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4113",
    d: "M-9.177-30.791a9.346,9.346,0,0,1-8.753-5.97,1.764,1.764,0,0,1,1-2.286,1.764,1.764,0,0,1,2.286,1,5.838,5.838,0,0,0,5.467,3.729,5.876,5.876,0,0,0,5.869-5.869,5.876,5.876,0,0,0-5.869-5.869,5.862,5.862,0,0,0-5.192,3.129,1.764,1.764,0,0,1-2.385.734,1.764,1.764,0,0,1-.734-2.385,9.383,9.383,0,0,1,8.311-5.007,9.409,9.409,0,0,1,9.4,9.4A9.409,9.409,0,0,1-9.177-30.791Z",
    transform: "translate(18.052 49.587)",
    fill: "#3b0310"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4115",
    transform: "translate(65.55 26.993)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4117",
    fill: "#3b0310"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4119",
    transform: "translate(13.605 2.313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4121",
    d: "M11.505,14.8a5.628,5.628,0,0,1-.965-.083l-5.665-.985a38,38,0,0,1-14.9-6.072h-3.209A1.764,1.764,0,0,1-15,5.9a1.764,1.764,0,0,1,1.764-1.764h3.764a1.764,1.764,0,0,1,1.021.325,34.432,34.432,0,0,0,13.931,5.8l5.665.985a2.1,2.1,0,0,0,1.373-3.9L4.449,2.881a5.021,5.021,0,0,1-2.59-4.393,5.026,5.026,0,0,1,5.02-5.02H18.755L14.6-9.735a8.386,8.386,0,0,0-5.095-1.736H-13.236A1.764,1.764,0,0,1-15-13.236,1.764,1.764,0,0,1-13.236-15H9.505a11.933,11.933,0,0,1,7.25,2.471L25.01-6.164A1.764,1.764,0,0,1,25.6-4.2,1.764,1.764,0,0,1,23.932-3H6.879A1.493,1.493,0,0,0,5.388-1.511a1.492,1.492,0,0,0,.769,1.3l8.069,4.462A5.625,5.625,0,0,1,11.505,14.8Z",
    transform: "translate(15 15)",
    fill: "#3b0310"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path4123",
    d: "M13.9-655.711H.1a1.764,1.764,0,0,1-1.764-1.764v-25.092A1.764,1.764,0,0,1,.1-684.332H13.9a1.764,1.764,0,0,1,1.764,1.764v25.092A1.764,1.764,0,0,1,13.9-655.711ZM1.862-659.239H12.134V-680.8H1.862Z",
    transform: "translate(1.471 684.136)",
    fill: "#3b0310"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g4125",
    transform: "translate(8.279 53.92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4127",
    d: "M-424.875-170.221H-455.6a22.107,22.107,0,0,1-15.735-6.518l-8.52-8.52a5.619,5.619,0,0,1-1.657-4.013,5.619,5.619,0,0,1,1.676-4.006,5.669,5.669,0,0,1,7.982.019l7.624,7.626a11.781,11.781,0,0,0,8.387,3.475h8.472a1.764,1.764,0,0,1,1.764,1.764,1.764,1.764,0,0,1-1.764,1.764h-8.472a15.287,15.287,0,0,1-10.882-4.508l-7.624-7.626a2.133,2.133,0,0,0-3-.007,2.114,2.114,0,0,0-.63,1.507,2.114,2.114,0,0,0,.623,1.51l8.52,8.52a18.6,18.6,0,0,0,13.24,5.484h30.724a1.764,1.764,0,0,1,1.764,1.764A1.764,1.764,0,0,1-424.875-170.221Z",
    transform: "translate(481.51 194.911)",
    fill: "#3b0310"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4129",
    transform: "translate(28.954 51.706)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4131",
    d: "M-170.471-123.753h-17.077a5.653,5.653,0,0,1-5.646-5.647,5.653,5.653,0,0,1,5.646-5.646h9.081l1.519-1.8a15.146,15.146,0,0,1,11.608-5.4,15.084,15.084,0,0,1,8.914,2.894l.228.165a1.764,1.764,0,0,1,.392,2.464,1.764,1.764,0,0,1-2.464.392l-.228-.165a11.577,11.577,0,0,0-6.842-2.221,11.625,11.625,0,0,0-8.909,4.144l-2.048,2.431a1.764,1.764,0,0,1-1.349.628h-9.9a2.12,2.12,0,0,0-2.118,2.118,2.12,2.12,0,0,0,2.118,2.118h17.077a1.764,1.764,0,0,1,1.764,1.764A1.764,1.764,0,0,1-170.471-123.753Z",
    transform: "translate(193.194 142.249)",
    fill: "#3b0310"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4133",
    transform: "translate(63.162 51.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4135",
    d: "M-116.768-199.712h-13.8a1.764,1.764,0,0,1-1.764-1.764v-25.092a1.764,1.764,0,0,1,1.764-1.764h13.8A1.764,1.764,0,0,1-115-226.568v25.092A1.764,1.764,0,0,1-116.768-199.712ZM-128.8-203.24h10.272V-224.8H-128.8Z",
    transform: "translate(132.333 228.333)",
    fill: "#3b0310"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcesoSolicitudCrditos);
export default __webpack_public_path__ + "static/media/Proceso_solicitud_créditos.80a21d72e4f134768c44f9fba172555a.svg";
export { ForwardRef as ReactComponent };